import React, { MutableRefObject, useContext, useEffect, useState } from "react";

import { ElementState, Preview } from "@creatomate/preview";
import { IconName } from "@culturehq/components/dist/components/Icon";
import { CreatomateContext } from "../../../contexts/VideoStudioContext";
import { getBarStyle } from "../utils";
import Container from "./Container";
import ImageBar from "../bar/ImageBar";

interface DraggableImageElementProps {
  barRef: MutableRefObject<HTMLDivElement>;
  currentElement: ElementState;
  onContextMenu: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  preview: Preview;
}

const DraggableImageElement: React.FC<DraggableImageElementProps> = ({
  barRef,
  currentElement,
  onContextMenu,
  preview
}) => {
  const { data: { activeElementsId } } = useContext(CreatomateContext);
  const active = activeElementsId.includes(currentElement.source.id);

  const [backgroundColor, setBackgroundColor] = useState("#3f4043");
  const [borderColor, setBorderColor] = useState("#3f4043");
  const [fontcolor, setFontColor] = useState("#3f4043");
  const [iconClass, setIconClass] = useState("camera");
  const [iconType, setIconType] = useState<IconName>("video-camera-filled");

  useEffect(
    () => {
      const {
        backgroundColor,
        borderColor,
        fontColor,
        iconClass,
        iconType
      } = getBarStyle(active, currentElement);

      setBorderColor(borderColor);
      setBackgroundColor(backgroundColor);
      setFontColor(fontColor);
      setIconClass(iconClass);
      setIconType(iconType);
    }, [currentElement, active]
  );

  return (
    <Container
      onClick={() => {
        preview.setActiveElements([currentElement.source.id]);
      }}
      onContextMenu={onContextMenu}
      ref={barRef}
      active={active}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      className="TimelineElement"
      color={fontcolor}
      dragging={false}
      style={{
        left: "0px",
        width: "100%"
      }}
      withVideos={false}
      isVideo={false}
      activeElementsLength={activeElementsId.length}
      smallElement
    >
      <ImageBar
        currentElement={currentElement}
        iconClass={iconClass}
        iconType={iconType}
      />
    </Container>
  );
};

export default DraggableImageElement;
